import { getShopIdFromLocation } from 'util/appUtils';
import {
  MERCHANDISING_READ_ACTIONS,
  createMerchandisingApi,
} from './merchandisingApi';

const shopPath = shopId => `/system/shop/${encodeURIComponent(shopId)}/merchandising/actions`;

/** Cloud/web-service transport for the shared merchandising.v1 action port. */
export function createLegacyMerchandisingApi({ client, shopId } = {}) {
  let resolvedClient = client || null;
  const getClient = () => {
    if (!resolvedClient) {
      // eslint-disable-next-line global-require
      resolvedClient = require('util/appUtils').wsClient;
    }
    return resolvedClient;
  };
  const getShopId = () => shopId || getShopIdFromLocation();

  return createMerchandisingApi({
    send: (action, payload) => getClient().prepareRequest(
      'POST',
      `${shopPath(getShopId())}/${MERCHANDISING_READ_ACTIONS.has(action) ? 'read' : 'write'}`,
      { body: { action, payload } },
    ),
  });
}
